import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MessageService} from '../../../../services/message.service';
import {SessionService} from '../../../../services/session.service';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import { UsersService } from '../../../../services/users.service';
import { UserI } from '../../../../interfaces/users/user.interface';

@Component({
  selector: 'app-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.scss']
})
export class UserFormComponent implements OnInit {

  @Input() user: UserI;
  @Output() userSubmit = new EventEmitter();
  @Output() closeModal = new EventEmitter();

  public userForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private userService: UsersService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.userForm = this.formBuilder.group({
      id: [''],
      name: [''],
      lastname: [''],
      email: ['',
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(80),
          Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')
        ]
      ],
      telephone: ['',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern('^[0-9]*$')
        ]
      ],
      password: [''],
      weight: [''],
      height: [''],
      waist: [''],
      active: ['']
    });
  }

  fillUserForm(data) {
    this.userForm.setValue({
      id: (data && data.id) ? data.id : '',
      name: (data && data.name) ? data.name : '',
      lastname: (data && data.lastname) ? data.lastname : '',
      email: (data && data.email) ? data.email : '',
      telephone: (data && data.telephone) ? data.telephone : '',
      password: (data && data.password) ? data.password : '',
      weight: (data && data.weight) ? data.weight : '',
      height: (data && data.height) ? data.height : '',
      waist: (data && data.waist) ? data.waist : '',
      active: (data && data.active) ? data.active : ''
    });

    if (data.password) {
      this.userForm.controls.password.disable();
    }
  }

  save() {
    if (this.userForm.invalid) {
      return false;
    }

    this.messageService.confirmRequest('¿Estás seguro de querer proceder ?').then((data) => {
      if (data.value) {
        if (this.userForm.controls.id.value || this.userForm.controls.id.value > 0) {
          this.messageService.printStatus('Esta acción esta en desarrollo', 'warning');
          return;
          this.userService.update(this.userForm.controls.id.value, this.userForm.value).subscribe(res => {
            if (res.ok === true) {
              this.userSubmit.emit(true);
              this.onClose();
              this.messageService.printStatus(res.message, 'success');
            }
          }, error =>  {
            this.messageService.printStatus(error.error.errors, 'error');
            console.log(error);
          });
        } else {
          this.userService.add(this.userForm.value).subscribe(res => {
            if (res.ok === true) {
              this.userSubmit.emit(true);
              this.onClose();
              this.messageService.printStatus(res.message, 'success');
            }
          }, error =>  {
            this.messageService.printStatus(error.error.errors, 'error');
            console.log(error);
          });
        }
      } else {
        this.messageService.dismissDelete();
      }
    });
  }

  onClose() {
    this.userForm.reset();
    this.closeModal.emit();
  }


  ngOnInit(): void {
    this.fillUserForm(this.data.user);
  }

}
